const addToCart = async (data) => fetch('/gift-card-site/add-to-cart', {
  method: 'POST',
  headers: {
    'Content-Type': 'application/json',
  },
  body: JSON.stringify(data),
});

export default {
  addToCart,
};
